import { SocialMediaMap } from "@dimensional-engineering/dimensional-models";

import styles from "./SocialLinks.module.css";

import {
  InstagramImage,
  LinkedInImage,
  TikTokImage,
  TwitterImage,
} from "./SocialMediaImages";

export default function SocialLinksPublicProfile(props: {
  data: SocialMediaMap | null | undefined;
  onClick: (type: "twitter" | "linkedin" | "tiktok" | "instagram") => void;
}) {
  return (
    <div className={styles.socialLinksContainerProfiles}>
      <TwitterImage
        onClick={() => props.onClick("twitter")}
        url={props.data?.twitter?.userName ?? null}
        noMoragin
      />
      <LinkedInImage
        onClick={() => props.onClick("linkedin")}
        url={props.data?.linkedIn?.userName ?? null}
        noMoragin
      />
      <InstagramImage
        onClick={() => props.onClick("instagram")}
        url={props.data?.instagram?.userName ?? null}
        noMoragin
      />
      <TikTokImage
        onClick={() => props.onClick("tiktok")}
        url={props.data?.tikTok?.userName ?? null}
        noMoragin
      />
    </div>
  );
}
